export default {"src":"/_next/static/media/rating-1.5.a7032c31.svg","height":96,"width":512,"blurWidth":0,"blurHeight":0};